import { authFetch, customEncode } from "../DecryptData";

/**
 * =========================================================
 * CONFIGURATION
 * =========================================================
 */
let BASE_URL =
  typeof window !== "undefined" && window.BASE_URL
    ? window.BASE_URL
    : process.env.REACT_APP_BASE_URL ||
    "http://anuplights.in:8083/apisecure/";

export const setBaseUrl = (url) => {
  if (!url) return;
  BASE_URL = url.endsWith("/") ? url : url + "/";
};

/**
 * =========================================================
 * INTERNAL HELPERS
 * =========================================================
 */

const wait = (ms) => new Promise((res) => setTimeout(res, ms));

const fetchWithTimeout = async (url, options = {}, timeout = 10000) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    const res = await authFetch(url, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);
    return res;
  } catch (err) {
    clearTimeout(id);
    throw err;
  }
};

export async function FetchImageByImageId(imageId) {
  const res = await authFetch(
    `${BASE_URL}GetImageUrlbyImageIdID`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ImageId: Number(imageId), // ✅ SENT DIRECTLY
      }),
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch image URL");
  }

  return await res.json();
}




const callServer = async (
  apiName,
  payload,
  {
    method = "POST",
    retries = 2,
    backoff = 500,
    timeout = 10000,
    plain = false, // ✅ ADD THIS
  } = {}
) => {
  if (!apiName) {
    throw new Error("API name is required");
  }

  const url = apiName.startsWith("http")
    ? apiName
    : `${BASE_URL}${apiName}`;

  let attempt = 0;

  while (true) {
    try {
      const res = await fetchWithTimeout(
        url,
        {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          body:
            payload !== undefined
              ? plain === true
                ? JSON.stringify(payload)
                : JSON.stringify({
                  data: customEncode(JSON.stringify(payload)),
                })
              : undefined,


        },
        timeout
      );

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text}`);
      }

      return await res.json();
    } catch (err) {
      const isNetwork =
        err.name === "AbortError" ||
        /network|failed|ECONNREFUSED/i.test(err.message);

      attempt++;
      if (attempt > retries) {
        const out = new Error(
          isNetwork
            ? "NetworkError: Unable to reach server"
            : err.message
        );
        out.original = err;
        throw out;
      }

      await wait(backoff * attempt);
    }
  }
};

/**
 * =========================================================
 * ✅ PUBLIC API – USE ONLY THESE 4 METHODS
 * =========================================================
 */

export const InsertToServer = (apiName, payload, options) => {
  return callServer(apiName, payload, options);
};

export const FetchFromServer = (apiName, payload, options) => {
  return callServer(apiName, payload, options);
};

export const UpdateToServer = (apiName, payload, options) => {
  return callServer(apiName, payload, options);
};

export const DeleteFromServer = (apiName, payload, options) => {
  return callServer(apiName, payload, options);
};

/**
 * =========================================================
 * ✅ PLAIN (NON-ENCRYPTED) API CALL
 * =========================================================
 */
export const FetchPlainFromServer = async (
  apiName,
  payload,
  { method = "POST", timeout = 10000 } = {}
) => {
  if (!apiName) throw new Error("API name is required");

  const url = apiName.startsWith("http")
    ? apiName
    : `${BASE_URL}${apiName}`;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  try {
    const res = await authFetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body: payload ? JSON.stringify(payload) : undefined,
      signal: controller.signal,
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`HTTP ${res.status}: ${text}`);
    }

    return await res.json();
  } finally {
    clearTimeout(id);
  }
};
